import captureStackTrace from 'capture-stack-trace';

export class SubscriptionsManager {

  subs: any = {};

  components = [
    'CampaignEditComponent',
    'CampaignsComponent',
    'ClientEditBillingComponent',
    'ClientEditDomainComponent',
    'ClientEditComponent',
    'FlowEditComponent',
    'FlowsComponent',
    'IntegrationEditComponent',
    'ListEditComponent',
    'ListsComponent',
    'LoginComponent',
    'MainComponent',
    'PopupEditComponent',
    'PopupsComponent',
    'ProfileEditComponent',
    'ProfilesComponent',
    'TemplateEditComponent',
    'TemplatesComponent',
    'UrlCheckerComponent',
    'UserSettingsComponent',
    'AppComponent',
  ]

  constructor(
  ) {
  }

  add(sub: any, id: any = -1) {
    if (id == -1) {
      // const execInfo = this.getExecInfo();
      // console.log('🚀 ~ SubscriptionsManager ~ add ~ execInfo:', execInfo);
      id = Object.keys(this.subs).length + '';
      /**
       * Buscamos un id único basado en una función y línea de la app,
       * si no lo encontramos colocamos uno numérico
       */
      // let start = 2;
      // if (Array.isArray(execInfo) && execInfo.length >= 2) {
      //   if (this.components.includes(execInfo[2][1].split('.')[0])) {
      //     id = execInfo[2][1] + '_'+ execInfo[2][2];
      //   } else {
      //     for (start = 3; start < execInfo.length; start++) {
      //       if (this.components.includes(execInfo[start][1].split('.')[0])) {
      //         id = execInfo[start][1] + '_'+ execInfo[start][2];
      //         break;
      //       }
      //     }
      //   }
      // }
      // console.log('🚀 ~ SubscriptionsManager ~ add ~ id:', id);
    }
    if (this.subs[id]) {
      this.subs[id].unsubscribe();
    }
    this.subs[id] = sub
  }

  remove(id: any = -1) {
    if (id == -1) {
      id = Object.keys(this.subs)[0];
    }
    if (this.subs[id]) {
      this.subs[id].unsubscribe();
      delete this.subs[id];
    }
  }

  unsubscribe(id: any = -1) {
    this.remove(id);
  }

  unsubscribeAll() {
    Object.keys(this.subs).forEach((k: any) => {
      this.unsubscribe(k);
    });
  }

  throwError() {
    throw new Error('tracing');
  }


  getErrorObject(){
    // try { throw Error('') } catch(err) { return err; }
    let obj: any = {};
    if ((Error as any).captureStackTrace) {
      (Error as any).captureStackTrace(obj, this.getErrorObject);
      return obj;
    } else {
      try {
        this.throwError();
      } catch (e: any) {
        return e;
      }
    }
    // captureStackTrace(obj);
    // return err.stack;

  }

  getExecInfo() {
    // const err = new Error();
    const err: any = this.getErrorObject();
    // const regex1 = /.*at\s+([^\s]+)\s\([^:]+:[^:]+:[^:]+:([^:]+)/g
    const regex1 = /.*at\s+([^\s]+)\s.*http[s]*:\/\/[^\/]+\/([^:]+):([^:]+)/g
    const regex2 = /([^@]+)@http[s]*:\/\/[^\/]+\/([^:]+):([^:]+)/g
    if (!err.stack) {
      err.stack = '';
    }
    // console.log('🚀 ~ SubscriptionsManager ~ getExecInfo ~ err.stack:', err.stack);
    let ret: any = []
    if ((Error as any).captureStackTrace) {
      ret = [...err.stack.matchAll(regex1)];
    } else {
      ret = [...err.stack.matchAll(regex2)];
    }

    return ret;
    // return [ret[0][1], ret[0][2]];
    // return [...err.stack.split("\n")[1]];
  }

}
